var _circle, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _circle2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStat2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#E5C774"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_21501_30267)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.9993,
    cy: 12.0599,
    r: 9.33333,
    fill: "#FDF18F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.9993,
    cy: 12.0599,
    r: 9.30303,
    stroke: "#FFF6BE",
    strokeWidth: 0.0606061
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_21501_30267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6935 12.044C20.6935 11.1851 20.5664 10.3308 20.3164 9.50907L11.9835 12.044H20.6935Z",
    fill: "#FDD748"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_21501_30267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2672 14.7355C20.5326 13.9186 20.6757 13.067 20.6919 12.2082L11.9835 12.044L20.2672 14.7355Z",
    fill: "#977ED2"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_21501_30267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.03 17.1636C19.5349 16.4687 19.9342 15.703 20.215 14.8912L11.9835 12.044L19.03 17.1636Z",
    fill: "#FDD748"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_21501_30267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1031 19.0906C17.798 18.5857 18.4144 17.9808 18.9323 17.2955L11.9835 12.044L17.1031 19.0906Z",
    fill: "#E82F65"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_21501_30267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.675 20.3277C15.4919 20.0623 16.2651 19.6775 16.9694 19.1858L11.9835 12.044L14.675 20.3277Z",
    fill: "#FDD748"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_21501_30267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9835 20.754C12.8424 20.754 13.6966 20.627 14.5184 20.377L11.9835 12.044V20.754Z",
    fill: "#977ED2"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_21501_30267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.29191 20.3277C10.1088 20.5932 10.9605 20.7363 11.8193 20.7525L11.9835 12.044L9.29191 20.3277Z",
    fill: "#FDD748"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_21501_30267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.86384 19.0906C7.55874 19.5954 8.3245 19.9947 9.13626 20.2755L11.9835 12.044L6.86384 19.0906Z",
    fill: "#E82F65"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_21501_30267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.9369 17.1636C5.44178 17.8585 6.04667 18.4749 6.73193 18.9928L11.9835 12.044L4.9369 17.1636Z",
    fill: "#FDD748"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_i_21501_30267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.69974 14.7355C3.96517 15.5525 4.34997 16.3256 4.84166 17.0299L11.9835 12.044L3.69974 14.7355Z",
    fill: "#977ED2"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_i_21501_30267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.27344 12.044C3.27344 12.9029 3.40049 13.7572 3.65048 14.5789L11.9835 12.044L3.27344 12.044Z",
    fill: "#FDD748"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_i_21501_30267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.69974 9.35246C3.43431 10.1694 3.29117 11.021 3.27498 11.8798L11.9835 12.044L3.69974 9.35246Z",
    fill: "#E82F65"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_i_21501_30267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.9369 6.92438C4.43203 7.61928 4.03272 8.38505 3.75194 9.1968L11.9835 12.044L4.9369 6.92438Z",
    fill: "#FDD748"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_i_21501_30267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.86384 4.99745C6.16894 5.50232 5.55254 6.10721 5.03465 6.79247L11.9835 12.044L6.86384 4.99745Z",
    fill: "#977ED2"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_i_21501_30267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.29191 3.76028C8.47501 4.02571 7.70186 4.41052 6.99756 4.9022L11.9835 12.044L9.29191 3.76028Z",
    fill: "#FDD748"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_i_21501_30267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9835 3.33398C11.1245 3.33398 10.2703 3.46104 9.44853 3.71102L11.9835 12.044V3.33398Z",
    fill: "#E82F65"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_i_21501_30267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.675 3.76028C13.8581 3.49485 13.0064 3.35172 12.1476 3.33553L11.9835 12.044L14.675 3.76028Z",
    fill: "#FDD748"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_i_21501_30267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1031 4.99745C16.4082 4.49258 15.6424 4.09327 14.8307 3.81249L11.9835 12.044L17.1031 4.99745Z",
    fill: "#977ED2"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_i_21501_30267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.03 6.92439C18.5251 6.22948 17.9203 5.61309 17.235 5.0952L11.9835 12.044L19.03 6.92439Z",
    fill: "#FDD748"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_i_21501_30267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2672 9.35246C20.0018 8.53556 19.6169 7.7624 19.1253 7.05811L11.9835 12.044L20.2672 9.35246Z",
    fill: "#E82F65"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.1213,
    cy: 12.0607,
    r: 1.99409,
    fill: "url(#paint0_radial_21501_30267)",
    stroke: "url(#paint1_linear_21501_30267)",
    strokeWidth: 0.375455
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_21501_30267",
    x: 2.60541,
    y: 2.66596,
    width: 18.7872,
    height: 18.7872,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.030303,
    result: "effect1_foregroundBlur_21501_30267"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_21501_30267",
    x: 11.9844,
    y: 9.50977,
    width: 8.70898,
    height: 2.89879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.363636
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.242424
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_21501_30267"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_21501_30267",
    x: 11.9844,
    y: 12.0449,
    width: 8.70703,
    height: 3.05504,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.363636
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.242424
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_21501_30267"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_21501_30267",
    x: 11.9844,
    y: 12.0449,
    width: 8.23047,
    height: 5.48278,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.363636
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.242424
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_21501_30267"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_21501_30267",
    x: 11.9844,
    y: 12.0449,
    width: 6.94727,
    height: 7.40856,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.363636
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.242424
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_21501_30267"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_21501_30267",
    x: 11.9844,
    y: 12.0449,
    width: 4.98438,
    height: 8.64684,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.363636
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.242424
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_21501_30267"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_21501_30267",
    x: 11.9844,
    y: 12.0449,
    width: 2.5332,
    height: 9.07262,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.363636
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.242424
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_21501_30267"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_21501_30267",
    x: 9.29102,
    y: 12.0449,
    width: 2.69336,
    height: 9.07067,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.363636
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.242424
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_21501_30267"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_21501_30267",
    x: 6.86328,
    y: 12.0449,
    width: 5.12109,
    height: 8.59411,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.363636
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.242424
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_21501_30267"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_21501_30267",
    x: 4.9375,
    y: 12.0449,
    width: 7.04688,
    height: 7.3109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.363636
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.242424
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_21501_30267"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_i_21501_30267",
    x: 3.69922,
    y: 12.0449,
    width: 8.28516,
    height: 5.34801,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.363636
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.242424
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_21501_30267"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_21501_30267",
    x: 3.27344,
    y: 12.0449,
    width: 8.71094,
    height: 2.89684,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.363636
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.242424
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_21501_30267"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_i_21501_30267",
    x: 3.27539,
    y: 9.35156,
    width: 8.70898,
    height: 3.057,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.363636
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.242424
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_21501_30267"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_i_21501_30267",
    x: 3.75195,
    y: 6.92383,
    width: 8.23242,
    height: 5.48473,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.363636
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.242424
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_21501_30267"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_i_21501_30267",
    x: 5.03516,
    y: 4.99805,
    width: 6.94922,
    height: 7.41051,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.363636
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.242424
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_21501_30267"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_i_21501_30267",
    x: 6.99805,
    y: 3.75977,
    width: 4.98633,
    height: 8.64879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.363636
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.242424
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_21501_30267"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_i_21501_30267",
    x: 9.44922,
    y: 3.33398,
    width: 2.53516,
    height: 9.07457,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.363636
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.242424
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_21501_30267"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_i_21501_30267",
    x: 11.9844,
    y: 3.33594,
    width: 2.69141,
    height: 9.07262,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.363636
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.242424
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_21501_30267"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_i_21501_30267",
    x: 11.9844,
    y: 3.8125,
    width: 5.11914,
    height: 8.59606,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.363636
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.242424
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_21501_30267"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_i_21501_30267",
    x: 11.9844,
    y: 5.0957,
    width: 7.04492,
    height: 7.31286,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.363636
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.242424
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_21501_30267"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_i_21501_30267",
    x: 11.9844,
    y: 7.05859,
    width: 8.2832,
    height: 5.34996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.363636
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.242424
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_21501_30267"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_21501_30267",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.1213 12.0607) rotate(90) scale(2.18182)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE0C40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21501_30267",
    x1: 12.1213,
    y1: 9.87891,
    x2: 12.1213,
    y2: 14.2425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA903"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStat2);
export default __webpack_public_path__ + "static/media/stat2.c1402ab96e3740ae0c641481649c386c.svg";
export { ForwardRef as ReactComponent };